import { api } from "./client";
import { commitOptions } from "./commitSeams";
import type { ZoomConnection } from "./zoom-admin";

export interface IntegrationOverview {
  observed_at: string;
  zoom: {
    supported: boolean;
    configured: boolean;
    creation_allowed: boolean;
    recordings_configured: boolean;
    recordings_enabled: boolean;
  };
}
export interface GoogleDiagnostics {
  observed_at: string;
  domain: string | null;
  signin: { configured: boolean; issuer: string | null };
  directory: {
    configured: boolean;
    provisioning_enabled: boolean;
    org_unit: string | null;
  };
  drive: {
    configured: boolean;
    enabled: boolean;
    root_id: string | null;
    operator: string | null;
    operator_matches_domain: boolean;
  };
  classroom: {
    supported: boolean;
    configured: boolean;
    intake_enabled: boolean;
    references_enabled: boolean;
    connection: {
      provider_user_id: string;
      grant_state: string;
      client_generation: string;
      revoked_at: string | null;
      scopes_missing: string[];
      client_current: boolean;
    } | null;
  };
  meet: { supported: boolean; configured: boolean; enabled: boolean };
}
export interface ZoomHost {
  user_id: string;
  display_name: string;
  is_active: boolean;
  role: string;
  host_binding_id: string | null;
  account_id: string | null;
  zoom_user_id: string | null;
  credential_generation: string | null;
  license_state: string | null;
  verified_at: string | null;
  revoked_at: string | null;
}
export interface ZoomManagement {
  connection: ZoomConnection | null;
  hosts: ZoomHost[];
  version: string;
}
export type ZoomAction =
  | "verify_account"
  | "verify_host"
  | "enable"
  | "disable"
  | "revoke_account"
  | "revoke_host";
export interface ZoomCommand {
  action: ZoomAction;
  expected_version: string;
  user_id?: string;
  zoom_user_id?: string;
  reason?: string;
}
export const integrationSettingsApi = {
  overview: () => api.get<IntegrationOverview>("/admin/settings/integrations"),
  google: () =>
    api.get<GoogleDiagnostics>("/admin/settings/integrations/google"),
  zoom: () => api.get<ZoomManagement>("/admin/zoom/management"),
  manageZoom: (body: ZoomCommand, key: string) =>
    api.post<{ state: "confirmed"; version: string }>(
      "/admin/zoom/management",
      body,
      commitOptions(key),
    ),
};
